module.exports = __webpack_public_path__ + "static/media/LeftIcon.39ba2ef7.svg";